import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { activeFilter, columnConfigs } from './listConfig';

const ConfigList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getGSTConfigData, gstOfferSegmentsData } = useService();
	if (actions?.addAction) actions.addAction.gstOfferSegmentsData = gstOfferSegmentsData;
	actions.rowActions[1].gstOfferSegmentsData = gstOfferSegmentsData;
	return (
		<div>
			<DataList
				fetchData={getGSTConfigData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.GST_CONFIGS}
				initialFilters={createInitialFilters(activeFilter)}
				initialSortDirection='ASC'
				initialSortIndex={1}
			/>
		</div>
	);
};

export default ConfigList;
